var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236.84 154.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .Slmcls-1 {\n        fill: none;\n      }\n\n      .Slmcls-1, .Slmcls-2 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .Slmcls-3 {\n        fill: #d7c9f4;\n      }\n\n      .Slmcls-2 {\n        fill: #227f22;\n      }\n\n      .Slmcls-4 {\n        fill: #bce29e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_26",
    "data-name": "Layer 26"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-3",
    x: 21.22,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 21.22,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_25",
    "data-name": "Layer 25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-4",
    x: 31.38,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 31.38,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_24",
    "data-name": "Layer 24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-4",
    x: 99.69,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 99.69,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_23",
    "data-name": "Layer 23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-4",
    x: 167.17,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 167.17,
    y: 28.54,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_22",
    "data-name": "Layer 22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-4",
    x: 31.79,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 31.79,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_21",
    "data-name": "Layer 21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-4",
    x: 100.11,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 100.11,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_20",
    "data-name": "Layer 20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-4",
    x: 167.59,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 167.59,
    y: 71.23,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_19",
    "data-name": "Layer 19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-4",
    x: 31.79,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 31.79,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_18",
    "data-name": "Layer 18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-4",
    x: 100.11,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 100.11,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_17",
    "data-name": "Layer 17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-4",
    x: 167.59,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Slmcls-1",
    x: 167.59,
    y: 113.92,
    width: 58.18,
    height: 32.2,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Slmcls-2",
    cx: 20.63,
    cy: 20.63,
    r: 20.13
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlime);
export default __webpack_public_path__ + "static/media/Slime.63af1c82d635cb8e308fc0ead2420eb3.svg";
export { ForwardRef as ReactComponent };